import { useConfigContext } from "shared/contexts/ConfigContext";

const RouteMiddleware = ({ children }: { children: any }): JSX.Element => {
  const { loaded } = useConfigContext();

  // We want to have all configs ready before rendering routes, otherwise
  // logic in routes that relies on config might fail
  if (!loaded) {
    return <></>;
  }

  return <>{children}</>;
};

export default RouteMiddleware;
